import { wrapCoordinates } from '../../components/features/Map/MapHelper';
import { IGetDatasetPanelDetails, IResult } from '../../types/api';
import { IBestDataset } from '../../types/search';
import { axiosInstance } from '../Api';

export default class SearchDetail {
  endPoint = 'SearchDetail';
  async getDatasetPanelDetails(
    coordinates: number[],
    dataset: string
  ): Promise<IGetDatasetPanelDetails> {
    const [longitude, latitude] = wrapCoordinates(coordinates);
    const r = await axiosInstance.get<IResult<IGetDatasetPanelDetails>>(
      `/${
        this.endPoint
      }/GetDatasetPanelDetails?latitude=${latitude}&longitude=${longitude}&DatasetId=${encodeURIComponent(
        dataset
      )}`
    );

    if (r.data.Error) {
      throw new Error(
        r.data.Error.ErrorMessage || 'Failed to fetch dataset panel details'
      );
    }

    return r.data.Result;
  }

  // oncloudonly needs to false: else offline data will be filtered out,
  // oncloudOnly = true will only return datasets ready to extract from Mike Cloud already.
  // In the url, “username” and “key” are optional. Please include them if user is logged in,
  // since some confidential datasets only allow certain users to access.
  //“oncloud=true” will only show datasets I’ve completed importing to Mike Cloud, while “false” will show all datasets in the list.
  // Please select results of “XX_Default” instead of the 1st item in the list of each category
  async getBestDatasets(coordinates: number[], includeFwe: boolean) {
    const [longitude, latitude] = wrapCoordinates(coordinates);
    try {
      const r = await axiosInstance.get<IResult<IBestDataset>>(
        `/${this.endPoint}/GetBestDatasets2?latitude=${latitude}&longitude=${longitude}&includeFwe=${includeFwe}`
      );
      return r.data.Result;
    } catch (error) {
      return null;
    }
  }

  searchDatasetDetail(id: string) {
    return axiosInstance
      .get(`/${this.endPoint}/SearchDataSetDetail?id=${encodeURIComponent(id)}`)
      .then((r) => r.data.Result);
  }
}
